import { useId, type SVGProps } from 'react';
const ParrotLogomark = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={52}
      height={52}
      fill="none"
      viewBox="0 0 52 52"
      role="img"
      aria-label="Parrot Analytics"
      focusable="false"
      {...props}
    >
      <path fill={`url(#${uid}a)`} d="M22.7 50.2v.8l.5-.4z" />
      <path fill={`url(#${uid}b)`} d="m25.5 48.3-2.8-2.8V47l2 2z" />
      <path fill={`url(#${uid}c)`} d="m27.8 45.9-5.1-5.1v1.9l4.2 4.2z" />
      <path fill={`url(#${uid}d)`} d="m30.2 43.6-7.5-7.5v2.2l6.4 6.4z" />
      <path fill={`url(#${uid}e)`} d="m32.5 41.2-9.8-9.8V34l8.6 8.5z" />
      <path fill={`url(#${uid}f)`} d="M34.9 38.9 22.7 26.7v2.9l10.7 10.7z" />
      <path fill={`url(#${uid}g)`} d="M37.2 36.5 22.7 22v3.2l12.9 12.9z" />
      <path fill={`url(#${uid}h)`} d="M39.6 34.2 22.7 17.3v3.6L37.8 36z" />
      <path fill={`url(#${uid}i)`} d="M41.9 31.8 22.7 12.6v3.9L40 33.8z" />
      <path fill={`url(#${uid}j)`} d="M44.3 29.5 22.7 8v4.2l19.5 19.4z" />
      <path fill={`url(#${uid}k)`} d="M46.5 27.2 22.7 3.4v4.4l21.6 21.6z" />
      <path fill={`url(#${uid}l)`} d="M48.2 25.5 22.7 0v3.3l23.9 23.8z" />
      <path fill={`url(#${uid}m)`} d="M46.6 27.1 22.7 3.3v.1l23.8 23.8z" />
      <path fill={`url(#${uid}n)`} d="M46.6 27.1 22.7 3.3v.1l23.8 23.8z" />
      <path fill="light-dark(#323232, #ADADAD)" d="m11.4 34.1-8.5-8.6 8.5-8.5z" />
      <defs>
        <linearGradient
          id={`${uid}a`}
          x1={23.099}
          x2={6.032}
          y1={51.398}
          y2={34.33}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}b`}
          x1={25.019}
          x2={3.119}
          y1={49.169}
          y2={27.269}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}c`}
          x1={27.122}
          x2={3.779}
          y1={46.938}
          y2={23.596}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}d`}
          x1={29.24}
          x2={5.262}
          y1={44.641}
          y2={20.663}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}e`}
          x1={31.371}
          x2={7.046}
          y1={42.429}
          y2={18.103}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}f`}
          x1={33.485}
          x2={8.932}
          y1={40.124}
          y2={15.572}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}g`}
          x1={35.634}
          x2={10.921}
          y1={37.874}
          y2={13.162}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}h`}
          x1={37.74}
          x2={12.914}
          y1={35.61}
          y2={10.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}i`}
          x1={39.856}
          x2={14.938}
          y1={33.318}
          y2={8.402}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}j`}
          x1={41.987}
          x2={17.004}
          y1={31.088}
          y2={6.105}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}k`}
          x1={44.103}
          x2={18.993}
          y1={28.834}
          y2={3.724}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}l`}
          x1={46.467}
          x2={20.75}
          y1={26.882}
          y2={1.168}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}m`}
          x1={46.992}
          x2={19.783}
          y1={27.694}
          y2={0.487}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}n`}
          x1={46.992}
          x2={19.783}
          y1={27.694}
          y2={0.487}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default ParrotLogomark;
